export const getLastDayOfMonth = (year: number, month: number) => {
  const nextMonthDate = new Date(year, month + 1, 1);
  const lastDayOfMonth = new Date(nextMonthDate.getTime() - 1);
  return lastDayOfMonth.getDate();
};
